__turbopack_context__.v({
  "helios-professor-card": "aX7rDq_helios-professor-card",
  "helios-professor-card--overlay": "aX7rDq_helios-professor-card--overlay",
  "helios-professor-card--stacked": "aX7rDq_helios-professor-card--stacked",
  "helios-professor-card__affiliation": "aX7rDq_helios-professor-card__affiliation",
  "helios-professor-card__body": "aX7rDq_helios-professor-card__body",
  "helios-professor-card__body--link": "aX7rDq_helios-professor-card__body--link",
  "helios-professor-card__copy": "aX7rDq_helios-professor-card__copy",
  "helios-professor-card__detail": "aX7rDq_helios-professor-card__detail",
  "helios-professor-card__frame": "aX7rDq_helios-professor-card__frame",
  "helios-professor-card__image": "aX7rDq_helios-professor-card__image",
  "helios-professor-card__name": "aX7rDq_helios-professor-card__name",
  "helios-professor-card__picture": "aX7rDq_helios-professor-card__picture",
});
